import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LayoutComponent} from "./layout/layout.component";
import {FileServiceTableComponent} from "./file-service-table/file-service-table.component";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {AllMastersDatabaseComponent} from "./all-masters-database/all-masters-database.component";
import {PureOriginalsComponent} from "./pure-originals/pure-originals.component";
import {UploadedPureOriginalsComponent} from './pure-originals/uploaded-pure-originals/uploaded-pure-originals.component';
import {DashboardMatchesComponent} from './pure-originals/dashboard-matches/dashboard-matches.component';
import {UploadedMastersComponent} from './all-masters-database/uploaded-masters/uploaded-masters.component';
import {MasterResultsComponent} from "./master-results/master-results.component";
import {MasterRecordsComponent} from "./all-masters-database/master-records/master-records.component";
import {PureOriginalDetailsComponent} from "./pure-originals/pure-original-details/pure-original-details.component";
import {LoginPageComponent} from "./login-page/login-page.component";
import {StatisticsComponent} from "./statistics/statistics.component";
import {UploadingActionsComponent} from "./uploading-actions/uploading-actions.component";
import {SystemInfoChartComponent} from "./statistics/system-info-chart/system-info-chart.component";
import {
    RequestedTunings
} from "./requested-tunings-wrapper/requested-tunings/requested-tunings";
import {
    RequestedTuningsTables
} from "./requested-tunings-wrapper/requested-tunings/requested-tunings-tables/requested-tunings-tables";
import {RegisterUserComponent} from "./register-user/register-user.component";
import {RegistrationTemplateComponent} from "./register-user/registration-template/registration-template.component";
import {ActivationTemplateComponent} from "./register-user/activation-template/activation-template.component";
import {UserSettingsPageComponent} from "./user-settings-page/user-settings-page.component";
import {AdminGuardService} from "./service/guards/admin-guard.service";
import {AdminPanelComponent} from "./admin-panel/admin-panel.component";
import {AuthGuard} from "./service/guards/auth.guard";
import {AllUsersTableComponent} from "./admin-panel/all-users-table/all-users-table.component";
import {TuningNamesTableComponent} from "./tuning-names-wrapper/tuning-names-table/tuning-names-table.component";

import {EcuBuildNamesTableComponent} from "./ecu-names-wrapper/ecu-build-names-table/ecu-build-names-table.component";
import {FaultyMastersComponent} from "./ecu-names-wrapper/faulty-masters/faulty-masters.component";
import {EcuNamesWrapperComponent} from "./ecu-names-wrapper/ecu-names-wrapper.component";
import {TuningNamesWrapperComponent} from "./tuning-names-wrapper/tuning-names-wrapper.component";
import {MasterDetailsWrapperComponent} from "./master-details-wrapper/master-details-wrapper.component";
import {RequestedTuningsWrapperComponent} from "./requested-tunings-wrapper/requested-tunings-wrapper.component";
import {ModeratorGuardService} from "./service/guards/moderator-guard.service";
import {
    PureOriginalTableWrapperComponent
} from "./pure-originals/pure-original-table-wrapper/pure-original-table-wrapper.component";
import {
    PureOriginalsMatchingDetailsTableComponent
} from "./pure-originals-matching-details-table/pure-originals-matching-details-table.component";
import {
    AllPossibleMatchingsTableComponent
} from "./all-possible-matchings-table/all-possible-matchings-table.component";
import {ForgotPasswordComponent} from "./login-page/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {
    ForgotPasswordVerificationComponent
} from "./login-page/forgot-password/forgot-password-verification/forgot-password-verification.component";
import {CorrectEcuProducersComponent} from "./correct-ecu-producers/correct-ecu-producers.component";
import {WinOlsTransactionComponent} from "./win-ols-transaction/win-ols-transaction.component";
import {
    TwoFactorLoginTemplateComponent
} from "./login-page/two-factor-login-template/two-factor-login-template.component";
import {LoginFormComponent} from "./login-page/login-form/login-form.component";
import {AllUsersStatisticsComponent} from "./statistics/user-statistics-wrapper/all-users-statistics/all-users-statistics.component";
import {
    UsersStatisticsDetailsComponent
} from "./statistics/user-statistics-wrapper/users-statistics-details/users-statistics-details.component";
import {UserStatisticsWrapperComponent} from "./statistics/user-statistics-wrapper/user-statistics-wrapper.component";
import {FaultyPureOriginalsComponent} from "./ecu-names-wrapper/faulty-pure-originals/faulty-pure-originals.component";
import {
    ResellerTuningCombinationsComponent
} from "./reseller-tuning-combinations/reseller-tuning-combinations.component";
import {FaultyEcuBuildsComponent} from "./ecu-names-wrapper/faulty-ecu-builds/faulty-ecu-builds.component";
import {
    PureOriginalsStatsComponent
} from "./statistics/user-statistics-wrapper/users-statistics-details/pure-originals-stats/pure-originals-stats.component";
import {
    MasterStatsComponent
} from "./statistics/user-statistics-wrapper/users-statistics-details/master-stats/master-stats.component";

import {WinOlsCustomersComponent} from "./win-ols-customers/win-ols-customers.component";
import {EmailNotificationsComponent} from "./email-notifications/email-notifications.component";
import {
    CustomerEmailDetailsComponent
} from "./email-notifications/customer-email-details/customer-email-details.component";
import {
    EmailNotificationsListComponent
} from "./email-notifications/email-notifications-list/email-notifications-list.component";
import {FaultyVehicleDataComponent} from "./ecu-names-wrapper/faulty-vehicle-data/faulty-vehicle-data.component";
import {WinOlsSolutionsWrapperComponent} from "./win-ols-solutions-wrapper/win-ols-solutions-wrapper.component";
import {
    WinOlsSolutionsOptionsOnlyComponent
} from "./win-ols-solutions-wrapper/win-ols-solutions-options-only/win-ols-solutions-options-only.component";
import {
    WinOlsSolutionsStage1OptionsComponent
} from "./win-ols-solutions-wrapper/win-ols-solutions-stage1-options/win-ols-solutions-stage1-options.component";
import {
    WinOlsSolutionsStage2OptionsComponent
} from "./win-ols-solutions-wrapper/win-ols-solutions-stage2-options/win-ols-solutions-stage2-options.component";
import {
    WinOlsSolutionsTcuOptionsComponent
} from "./win-ols-solutions-wrapper/win-ols-solutions-tcu-options/win-ols-solutions-tcu-options.component";
import {
    WinOlsSolutionsTcuTuningComponent
} from "./win-ols-solutions-wrapper/win-ols-solutions-tcu-tunings/win-ols-solutions-tcu-tuning.component";
import {
    WinOlsSolutionsVersionCommentsComponent
} from "./win-ols-solutions-wrapper/win-ols-solutions-version-comments/win-ols-solutions-version-comments.component";
import {VehicleProducersTableComponent} from "./vehicle-producers-table/vehicle-producers-table.component";
import {VehicleTypesTableComponent} from "./vehicle-types-table/vehicle-types-table.component";


const routes: Routes = [
    {
        path: 'app', component: LayoutComponent, canActivate: [AuthGuard], children: [
            {path: '', component: DashboardComponent},
            {
                path: 'admin-panel', component: AdminPanelComponent, canActivate: [AdminGuardService], children: [
                    {path: '', component: AllUsersTableComponent},
                ]
            },
            {
                path: 'statistics', component: StatisticsComponent, canActivate: [AdminGuardService], children: [
                    {path: 'system-info', component: SystemInfoChartComponent}
                ]
            },

            {path: 'dashboard-analytics', redirectTo: '', pathMatch: 'full'},
            {path: 'upload-files', component: UploadingActionsComponent},
            {path: 'file-service', component: FileServiceTableComponent, canActivate: [AdminGuardService]},
            {
                path: 'stage-clusters',
                loadComponent: () => import('./stage-clusters/stage-clusters.component').then(m => m.StageClustersComponent),
                canActivate: [ModeratorGuardService]
            },
            {
                path: 'master-database',
                component: AllMastersDatabaseComponent,
                canActivate: [AdminGuardService],
                children: [
                    {path: '', pathMatch: 'full', component: MasterRecordsComponent},
                    {path: 'uploaded', component: UploadedMastersComponent}
                ]
            },
            {
                path: 'pure-originals',
                component: PureOriginalsComponent,
                canActivate: [ModeratorGuardService],
                children: [
                    {path: '', component: PureOriginalTableWrapperComponent},
                    {path: 'uploaded', component: UploadedPureOriginalsComponent},
                    {path: 'matches/:target', component: DashboardMatchesComponent},
                    {path: 'pure-original-details', component: PureOriginalDetailsComponent},
                ]
            },
            {
                path: 'pure-originals-matching-table',
                component: PureOriginalsMatchingDetailsTableComponent,
                canActivate: [ModeratorGuardService]
            },
            {
                path: 'all-possible-matchings-table',
                component: AllPossibleMatchingsTableComponent,
                canActivate: [ModeratorGuardService]
            },
            {
                path: 'master-details/:id',
                component: MasterDetailsWrapperComponent,
            },
            {
                path: 'custom-functions',
                loadComponent: () => import('./custom-functions/custom-functions.component').then(m => m.CustomFunctionsComponent),
                canActivate: [AdminGuardService]
            },
            {
                path: 'ai-finisher',
                loadComponent: () => import('./ai-finisher/ai-finisher.component').then(m => m.AiFinisherComponent),
                canActivate: [AdminGuardService]
            },

            {
                path: 'requested-tunings',
                component: RequestedTuningsWrapperComponent,
                canActivate: [ModeratorGuardService],
                children: [
                    {path: '', component: RequestedTunings},
                    {path: 'requested-tunings-tables', component: RequestedTuningsTables}
                ]
            },
            {
                path: 'results-card', component: RequestedTunings, children: [
                    {path: '', component: RequestedTuningsTables}
                ]
            },
            {
                path: 'ecu-names', component: EcuNamesWrapperComponent, canActivate: [AdminGuardService], children: [
                    {path: 'ecu-build-names', component: EcuBuildNamesTableComponent},
                    {
                        path: 'detected-ecu-builds',
                        canActivate: [AdminGuardService],
                        loadComponent: () => import('./ecu-names-wrapper/detected-ecu-builds/detected-ecu-builds.component').then(m => m.DetectedEcuBuildsComponent)
                    },
                    {path: 'correct-ecu-producers', component: CorrectEcuProducersComponent},
                    {path: 'vehicle-producers-table',component: VehicleProducersTableComponent},
                    {path: 'vehicle-types-table', component: VehicleTypesTableComponent},
                    {path: 'faulty-masters', component: FaultyMastersComponent},
                    {path: 'faulty-pure-originals', component: FaultyPureOriginalsComponent},
                    {path: 'faulty-ecu-builds', component: FaultyEcuBuildsComponent},
                    {path: 'faulty-vehicle-data', component: FaultyVehicleDataComponent},
                ]
            },

            {
                path: 'tuning-wrapper-names',
                component: TuningNamesWrapperComponent,
                canActivate: [AdminGuardService],
                children: [
                    {path: 'tuning-names', component: TuningNamesTableComponent},
                    {path: 'reseller-tuning-combinations', component: ResellerTuningCombinationsComponent}
                ]
            },

            {path: 'win-ols-solutions-wrapper', component: WinOlsSolutionsWrapperComponent, canActivate: [AdminGuardService],
                children:[
                    {path: 'win-ols-solutions-options-only', component: WinOlsSolutionsOptionsOnlyComponent},
                    {path: 'win-ols-solutions-stage1-options', component: WinOlsSolutionsStage1OptionsComponent },
                    {path: 'win-ols-solutions-stage2-options', component: WinOlsSolutionsStage2OptionsComponent},
                    { path: 'win-ols-solutions-tcu-options', component: WinOlsSolutionsTcuOptionsComponent},
                    {path: 'win-ols-solutions-tcu-tuning', component: WinOlsSolutionsTcuTuningComponent},
                    {path: 'win-ols-solutions-version-comments', component: WinOlsSolutionsVersionCommentsComponent}
                ]
            },

            {path: 'masters-results', component: MasterResultsComponent, canActivate: [AdminGuardService]},
            {path: 'user-settings', component: UserSettingsPageComponent},
            {path: 'win-ols-customers', component: WinOlsCustomersComponent},
            {path: 'win-ols-transactions', component: WinOlsTransactionComponent, canActivate: [AdminGuardService]},
            {path: 'win-ols-transactions/:transactionId', component: WinOlsTransactionComponent, canActivate: [AdminGuardService]},

            {path: 'winOls-transactions', component: WinOlsTransactionComponent},
            {
                path: 'email-notifications',
                component: EmailNotificationsComponent,
                children: [
                    {
                        path: '',
                        component: EmailNotificationsListComponent
                    },
                    {
                        path: 'customer-details',
                        component: CustomerEmailDetailsComponent
                    }
                ]
            },

            {path: 'user-statistics', component: UserStatisticsWrapperComponent, children: [
                    {path: "", redirectTo: "all-users", pathMatch: "full"},
                    {path: "all-users", component: AllUsersStatisticsComponent},
                    {path: ':id', component: UsersStatisticsDetailsComponent, children: [
                            {path: 'master-stats', component: MasterStatsComponent},
                            {path: 'pure-original-stats', component: PureOriginalsStatsComponent},
                        ]}
                ]
            },
        ]
    },
    {
        path: 'login', component: LoginPageComponent, children: [
            {path: "", component: LoginFormComponent},
            {path: "two-factor", component: TwoFactorLoginTemplateComponent},
        ]
    },
    {path: "forgot-password", component: ForgotPasswordComponent},
    {path: "forgot-password-verification", component: ForgotPasswordVerificationComponent},
    {path: "reset-password", component: ResetPasswordComponent},
    {path: 'register', component: ActivationTemplateComponent},
    {path: 'signup', component: RegisterUserComponent},
    {path: 'verification', component: RegistrationTemplateComponent},
    {path: '', redirectTo: 'app', pathMatch: "full"}

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
